import { ROUTES } from '@/shared/constants';

export const toSafeRedirectPath = (path: unknown): string => {
  if (typeof path !== 'string') {
    return ROUTES.home;
  }

  const normalized = [...path]
    .filter((character) => {
      return character > ' ';
    })
    .join('');

  if (!normalized.startsWith('/')) {
    return ROUTES.home;
  }

  if (normalized.startsWith('//') || normalized.startsWith('/\\')) {
    return ROUTES.home;
  }

  return path;
};
